import styled from 'styled-components';
import { useCameraViewContext } from '../../context';
import { useTipsText } from '../controls/useTipsText';

const Text = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 14.06px;
  color: #cccccc;
`;

export const HelperText = () => {
  const { showHelperText } = useCameraViewContext();

  const tipsText = useTipsText();
  console.log(tipsText);

  if (!showHelperText) {
    return null;
  }

  return <Text>{tipsText}</Text>;
};
